<div class="dotsSpinner" [hidden]="!showLoading">
    <div class="dotsBounce1"></div>
    <div class="dotsBounce2"></div>
    <div class="dotsBounce3"></div>
</div>
